// Test IDs for MyFamShield feature areas. See ./auth.js for the directive.

export const APP = {
	logo: 'app-logo',
	logoutButton: 'app-logout-button',
	userMenu: 'app-user-menu',
};

export const NAV = {
	dashboard: 'nav-dashboard',
	assessment: 'nav-assessment',
	progress: 'nav-progress',
	coach: 'nav-coach',
	library: 'nav-library',
	vault: 'nav-vault',
	subscription: 'nav-subscription',
	notifications: 'nav-notifications',
	admin: 'nav-admin',
	superAdmin: 'nav-super-admin',
};

export const LANDING = {
	getStartedButton: 'landing-get-started-button',
	loginButton: 'landing-login-button',
};

export const LOGIN_EXT = {
	googleButton: 'login-google-button',
	otpButton: 'login-otp-button',
	emailTabButton: 'login-email-tab-button',
	otpTabButton: 'login-otp-tab-button',
	mobileInput: 'login-mobile-input',
	otpInput: 'login-otp-input',
	requestOtpButton: 'login-request-otp-button',
	verifyOtpButton: 'login-verify-otp-button',
	rememberMe: 'login-remember-me',
	createAccountLink: 'login-create-account-link',
};

export const DASHBOARD = {
	root: 'dashboard-root',
	scoreCircle: 'dashboard-score-circle',
	startAssessmentButton: 'dashboard-start-assessment-button',
	missionCard: 'dashboard-mission-card',
	topStrengths: 'dashboard-top-strengths',
	topRisks: 'dashboard-top-risks',
};

export const ASSESSMENT = {
	root: 'assessment-root',
	nextButton: 'assessment-next-button',
	prevButton: 'assessment-prev-button',
	submitButton: 'assessment-submit-button',
	progress: 'assessment-progress',
	option: 'assessment-option',
};

export const SCORE = {
	root: 'score-root',
	downloadButton: 'score-download-button',
	backToDashboard: 'score-back-to-dashboard',
};

export const COACH = {
	root: 'coach-root',
	input: 'coach-input',
	sendButton: 'coach-send-button',
	message: 'coach-message',
};

export const LIBRARY = {
	root: 'library-root',
	card: 'library-card',
};

export const VAULT = {
	root: 'vault-root',
	passphraseInput: 'vault-passphrase-input',
	unlockButton: 'vault-unlock-button',
	createButton: 'vault-create-button',
	itemLabelInput: 'vault-item-label-input',
	itemBodyInput: 'vault-item-body-input',
	saveButton: 'vault-save-button',
	categoryInput: 'vault-category-input',
};

export const SUBSCRIPTION = {
	root: 'subscription-root',
	upgradeButton: 'subscription-upgrade-button',
	downgradeButton: 'subscription-downgrade-button',
};

export const ADMIN = {
	root: 'admin-root',
	usersTab: 'admin-users-tab',
	contentTab: 'admin-content-tab',
	analyticsTab: 'admin-analytics-tab',
	auditTab: 'admin-audit-tab',
	settingsTab: 'admin-settings-tab',
	suspendButton: 'admin-suspend-button',
	deleteButton: 'admin-delete-button',
	roleSelect: 'admin-role-select',
};
